import { useMemo, useState } from "react";
import { Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPowerOff } from "@fortawesome/free-solid-svg-icons";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimeField } from "@mui/x-date-pickers/DateTimeField";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";

import Container from "../container";

import styles from "./styles.module.scss";

const units = [
  { label: "Minutes", value: "m" },
  { label: "Hours", value: "h" },
  { label: "Days", value: "d" },
  { label: "Weeks", value: "w" },
  { label: "Months", value: "M" },
  { label: "Years", value: "y" }
];

export default function Range({
  startDate,
  period,
  unit,
  onChangeStartDate,
  onChangePeriod,
  onChangeUnit,
  extra,
  errors,
  color
}) {
  const [show, setShow] = useState(startDate ? true : false);
  const [isValid, setIsValid] = useState(true);

  const header = useMemo(() => {
    return (
      <div className={styles.rangeHeader}>
        <div className={styles.period}>
          <Form.Control
            type="number"
            min={1}
            step={1}
            value={period || 0}
            onChange={(e) => onChangePeriod(e.target.value)}
            isInvalid={errors?.rangePeriod}
            className={styles.numericField}
          />
        </div>
        <div className={styles.unit}>
          <Form.Control
            as="select"
            value={unit || ""}
            onChange={(e) => onChangeUnit(e.target.value)}
            isInvalid={errors?.rangeUnit}
          >
            <option></option>
            {units.map((u) => (
              <option value={u.value} key={u.label}>
                {u.label}
              </option>
            ))}
          </Form.Control>
        </div>
        <div className={styles.start}>
          <span className={styles.label}>Before</span>
          {show && (
            <LocalizationProvider
              dateAdapter={AdapterMoment}
              adapterLocale="it"
            >
              <DateTimeField
                value={startDate ? moment(startDate) : null}
                onChange={(v) => {
                  const valid = v.isValid();
                  setIsValid(valid);
                  if (valid) {
                    onChangeStartDate(v.toISOString());
                  }
                }}
                hiddenLabel={true}
                className={styles.single}
                error={!isValid}
                size="small"
              />
              <FontAwesomeIcon
                icon={faPowerOff}
                className={styles.resetStartDate}
                onClick={() => {
                  onChangeStartDate(undefined);
                  setShow(false);
                }}
              />
            </LocalizationProvider>
          )}
          {!startDate && !show && (
            <span className={styles.startDate} onClick={() => setShow(true)}>
              Now
            </span>
          )}
        </div>
      </div>
    );
  }, [
    errors?.rangePeriod,
    errors?.rangeUnit,
    isValid,
    onChangePeriod,
    onChangeStartDate,
    onChangeUnit,
    period,
    show,
    startDate,
    unit
  ]);

  return (
    <Container
      title="Range"
      help="relative-range"
      color={color}
      coloredBars={false}
      foldable={false}
      folded={true}
      extra={extra}
      header={header}
      warning={errors?.range}
    ></Container>
  );
}
